import { render, staticRenderFns } from "./GdprDatatable.vue?vue&type=template&id=2782dff0"
import script from "./GdprDatatable.vue?vue&type=script&lang=js"
export * from "./GdprDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports